import { styled } from '@mui/system';
import { Card, Typography, IconButton } from '@mui/material';

export const StyledCard = styled(Card)(() => ({
  padding: '16px',
  marginBottom: '8px',
  boxShadow: 'none'
}));

export const CardRow = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px'
}));

export const LastRow = styled(CardRow)(() => ({
  marginBottom: 0
}));

export const CardTitle = styled(Typography)(() => ({
  display: 'flex',
  padding: 0,
  margin: 0,
  alignItems: 'center',
  marginRight: '60px',
  whiteSpace: 'initial',
  overflowWrap: 'break-word'
}));

export const ContentInfo = styled(Typography)(() => ({
  textAlign: 'right',
  maxWidth: '250px'
}));

export const CardIcon = styled('span')(() => ({
  marginRight: '8px'
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const Title2 = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 0
  }
}));

export const MoreIconButton = styled(IconButton)(() => ({
  zIndex: '1000'
}));
